import { type FC, useEffect, useState } from 'react';
import * as Styled from './burger-menu-button.styles';

interface BurgerMenuButtonProps {
    isOpen: boolean;
    toggleMenu: () => void;
}

export const BurgerMenuButton: FC<BurgerMenuButtonProps> = ({ isOpen, toggleMenu }) => {
    const [tapAnimate, setTapAnimate] = useState(false);

    useEffect(() => {
        let timerId: ReturnType<typeof setTimeout>;

        if (tapAnimate) {
            timerId = setTimeout(() => setTapAnimate(false), 500);
        }

        return () => clearTimeout(timerId);
    }, [tapAnimate]);

    return (
        <Styled.BurgerButton
            tapAnimate={tapAnimate}
            onClick={toggleMenu}
            onTouchStart={() => setTapAnimate(true)}
        >
            <Styled.BarsContainer isOpen={isOpen}>
                <Styled.MenuTopBar />
                <Styled.MenuMiddleBar />
                <Styled.MenuBottomBar />
            </Styled.BarsContainer>
        </Styled.BurgerButton>
    );
};
